import React, { Component } from "react";
import Button from "../../blocks/Button";
import ButtonSet from "../../blocks/ButtonSet";
import Modal from "../../common/Modal";
import { MenuList, MenuListItem } from "../../blocks/MenuList";
import { css } from "glamor";
import { dimensions } from "../../../style";

const buttonSetStyle = {
  "& > div": {
    padding: "4px 0",
    ":last-child": {
      marginRight: "auto"
    },
    [dimensions.SCREEN_MAX_SM]: {
      width: "100%",
      maxWidth: 200,
      margin: "0 auto",
    }
  },
  "& .modalCell > button": {
    width: "100%"
  },
  [dimensions.SCREEN_MAX_SM]: {
    display: "flex",
    flexDirection: "column",
  }
};

class ProfileActions extends Component {
  constructor(props) {
    super(props);
    this.renderFavoriteButton = this.renderFavoriteButton.bind(this);
    this.renderMessageBtn = this.renderMessageBtn.bind(this);
  }

  renderFavoriteButton(favorited) {
    if (favorited) {
      return (
        <Button
          variant="primary"
          onClick={() => {
            this.props.toggleFav(this.props.username);
          }}
          fit={true}
        >
          <svg width="18" height="18" viewBox="0 0 30 30">
            <path
              fill="#fff"
              d="M10.2732671,9.66666667 L13.5174678,0.845833333 C13.7626601,0.3625 14.2530447,0 14.7434293,0 C15.233814,0 15.7241986,0.3625 15.8467947,0.845833333 L19.0909955,9.66666667 L28.2290063,9.66666667 C28.7193909,9.66666667 29.2097755,10.0291667 29.4549678,10.5125 C29.577564,10.9958333 29.4549678,11.6 28.9645832,11.8416667 L21.9290254,16.9341115 L25.7770832,27.3083333 C26.0222755,27.7916667 25.7770832,28.3958333 25.4092947,28.6375 C25.0415063,28.8791667 24.796314,29 24.5511217,29 C24.3059293,29 24.060737,28.8791667 23.8155447,28.7583333 L14.6821313,22.1192969 L5.54871781,28.7583333 C5.42612166,28.8791667 5.18092935,29 4.93573704,29 C4.69054473,29 4.44535243,28.8791667 4.20016012,28.7583333 C3.7097755,28.3958333 3.58717935,27.9125 3.83237166,27.4291667 L7.63285243,17.0375 L0.522275502,11.8416667 C0.154487041,11.4791667 -0.0907052668,10.9958333 0.0318908871,10.5125 C0.277083195,10.0291667 0.76746781,9.66666667 1.25785243,9.66666667 L10.2732671,9.66666667 L10.2732671,9.66666667 Z M12.1392522,11.5066657 C12.2008198,11.4240717 12.2524001,11.3338596 12.2915063,11.2375 L14.7434293,4.7125 L17.1953524,11.2375 C17.3179486,11.7208333 17.8083332,12.0833333 18.2987178,12.0833333 L18.5439101,12.0833333 L24.5511217,12.0833333 L19.9397168,15.3785287 C19.7723322,15.4579677 19.6257818,15.5740454 19.5083833,15.7130985 C19.1369314,16.1193569 19.0719407,16.8453061 19.4020832,17.2791667 C19.4075022,17.2871783 19.4129811,17.2950719 19.4185185,17.3028487 L21.9766024,24.4083333 L15.4790063,19.6958333 C15.2609515,19.5346438 14.9701763,19.4690205 14.6821313,19.4883398 C14.3940862,19.4690205 14.1033111,19.5346438 13.8852563,19.6958333 L7.38766012,24.4083333 L10.2073717,16.9166667 C10.452564,16.4333333 10.3299678,15.95 9.83958319,15.5875 L4.93573704,12.0833333 L11.0655447,12.0833333 C11.5576746,12.0833333 11.9400531,11.8669867 12.1392522,11.5066657 L12.1392522,11.5066657 Z"
              id="Combined-Shape"
            />
          </svg>
          <span>&nbsp; Favorited</span>
        </Button>
      );
    } else {
      return (
        <Button
          variant="simple"
          onClick={() => {
            this.props.toggleFav(this.props.username);
          }}
          fit={true}
        >
          <svg width="18" height="18" viewBox="0 0 30 30">
            <path
              fill="#ccc"
              d="M10.2732671,9.66666667 L13.5174678,0.845833333 C13.7626601,0.3625 14.2530447,0 14.7434293,0 C15.233814,0 15.7241986,0.3625 15.8467947,0.845833333 L19.0909955,9.66666667 L28.2290063,9.66666667 C28.7193909,9.66666667 29.2097755,10.0291667 29.4549678,10.5125 C29.577564,10.9958333 29.4549678,11.6 28.9645832,11.8416667 L21.9290254,16.9341115 L25.7770832,27.3083333 C26.0222755,27.7916667 25.7770832,28.3958333 25.4092947,28.6375 C25.0415063,28.8791667 24.796314,29 24.5511217,29 C24.3059293,29 24.060737,28.8791667 23.8155447,28.7583333 L14.6821313,22.1192969 L5.54871781,28.7583333 C5.42612166,28.8791667 5.18092935,29 4.93573704,29 C4.69054473,29 4.44535243,28.8791667 4.20016012,28.7583333 C3.7097755,28.3958333 3.58717935,27.9125 3.83237166,27.4291667 L7.63285243,17.0375 L0.522275502,11.8416667 C0.154487041,11.4791667 -0.0907052668,10.9958333 0.0318908871,10.5125 C0.277083195,10.0291667 0.76746781,9.66666667 1.25785243,9.66666667 L10.2732671,9.66666667 L10.2732671,9.66666667 Z M12.1392522,11.5066657 C12.2008198,11.4240717 12.2524001,11.3338596 12.2915063,11.2375 L14.7434293,4.7125 L17.1953524,11.2375 C17.3179486,11.7208333 17.8083332,12.0833333 18.2987178,12.0833333 L18.5439101,12.0833333 L24.5511217,12.0833333 L19.9397168,15.3785287 C19.7723322,15.4579677 19.6257818,15.5740454 19.5083833,15.7130985 C19.1369314,16.1193569 19.0719407,16.8453061 19.4020832,17.2791667 C19.4075022,17.2871783 19.4129811,17.2950719 19.4185185,17.3028487 L21.9766024,24.4083333 L15.4790063,19.6958333 C15.2609515,19.5346438 14.9701763,19.4690205 14.6821313,19.4883398 C14.3940862,19.4690205 14.1033111,19.5346438 13.8852563,19.6958333 L7.38766012,24.4083333 L10.2073717,16.9166667 C10.452564,16.4333333 10.3299678,15.95 9.83958319,15.5875 L4.93573704,12.0833333 L11.0655447,12.0833333 C11.5576746,12.0833333 11.9400531,11.8669867 12.1392522,11.5066657 L12.1392522,11.5066657 Z"
              id="Combined-Shape"
            />
          </svg>
          <span>&nbsp; Favorite</span>
        </Button>
      );
    }
  }

  renderMoreModal() {
    return (
      <Modal buttonText={`More`}>
        <MenuList>
          <MenuListItem centered>
            <Button fit={true} to={`/report/${this.props.username}`}>
              Report User
            </Button>
          </MenuListItem>
          <MenuListItem centered>
            <Button
              fit
              to=""
              onClick={() => {
                this.props.toggleBlock(this.props.username);
              }}
            >
              {this.props.isBlocked ? "Unblock User" : "Block User"}
            </Button>
          </MenuListItem>
        </MenuList>
      </Modal>
    );
  }

  renderMessageBtn() {
    if (this.props.canMsg)
      return (
        <Button
          to={`/messages/${this.props.username}`}
          fit={true}
          variant="primary"
        >
          <svg width="18" height="18" viewBox="0 0 64 64">
            <path
              fill="#fff"
              d="M62,17.21 C62,12.6757422 58.3242578,9 53.79,9 L10.21,9 C5.6757422,9 2,12.6757422 2,17.21 L2,46.79 C2,51.3242578 5.6757422,55 10.21,55 L53.8,55 C58.3303521,54.9944819 62.0000034,51.3203554 62,46.79 L62,17.21 L62,17.21 Z M53.79,15 C54.092363,14.9761145 54.3965906,15.0031569 54.69,15.08 L31.91,33.27 L9.12,15.09 C9.40642419,15.0120049 9.7037172,14.9815999 10,15 L53.77,15 L53.79,15 Z M53.79,49 L10,49 C8.49,49 8,47.82 8,46.31 L8,20.54 L29,38 C30.7064553,39.5324352 33.2935447,39.5324352 35,38 L56,20.54 L56,46.31 C56,47.82 55.3,49 53.79,49 L53.79,49 Z"
            />
          </svg>
          <span>
            &nbsp; {this.props.threadExists ? "View Conversation" : "Message"}
          </span>
        </Button>
      );
    else return null;
  }

  render() {
    let msgBtn = null;
    let favBtn = null;
    let unblockBtn = (
      <Button
        fit
        variant="simple"
        onClick={() => {
          this.props.toggleBlock(this.props.username);
        }}
      >
        Unblock
      </Button>
    );

    if (!this.props.isBlocked) {
      msgBtn = this.renderMessageBtn();
      favBtn = this.renderFavoriteButton(this.props.isFavorite);
      unblockBtn = null;
    }

    return (
      <ButtonSet styles={css(buttonSetStyle)}>
        {msgBtn}
        {favBtn}
        {unblockBtn}
        {this.renderMoreModal()}
      </ButtonSet>
    );
  }
}

export default ProfileActions;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/ProfileActions.jsx